"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _dailySettlementStatement = require("@/api/financialManagement/dailySettlementStatement");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'DailySettlements',
  data: function data() {
    return {
      marginWidth: '150px',
      ruleForm: {
        mode: null,
        amount: null,
        delay: null,
        unionCode: 'PDD'
      },
      rules: {
        mode: [{
          required: true,
          message: '请选择结算模式',
          trigger: 'change'
        }],
        amount: [{
          required: true,
          message: '请输入提现金额',
          trigger: 'blur'
        }],
        delay: [{
          required: true,
          message: '请输入确认收货时间',
          trigger: 'blur'
        }]
      }
    };
  },
  created: function created() {
    this.getConfig();
  },
  methods: {
    getConfig: function () {
      var _getConfig = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee() {
        var res;
        return (0, _regenerator2.default)().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return (0, _dailySettlementStatement.getConfigApi)({
                unionCode: 'PDD'
              });
            case 1:
              res = _context.v;
              if (res.code === 0) {
                this.ruleForm.amount = res.data.amount;
                this.ruleForm.delay = res.data.delay;
                this.ruleForm.mode = res.data.mode;
              }
            case 2:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function getConfig() {
        return _getConfig.apply(this, arguments);
      }
      return getConfig;
    }(),
    ConfigApi: function () {
      var _ConfigApi2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee2(data) {
        var res;
        return (0, _regenerator2.default)().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return (0, _dailySettlementStatement.ConfigApi)(data);
            case 1:
              res = _context2.v;
              if (res.code === 0) {
                this.$message({
                  message: '保存成功',
                  type: 'success'
                });
                this.getConfig();
              }
            case 2:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function ConfigApi(_x) {
        return _ConfigApi2.apply(this, arguments);
      }
      return ConfigApi;
    }(),
    // 保存
    save: function save() {
      var _this = this;
      this.$refs.ruleForm.validate(function (valid) {
        if (valid) {
          _this.$confirm('是否确认修改此配置?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(function () {
            _this.ConfigApi(_this.ruleForm);
          });
        }
      });
    }
  }
};